// extracted by mini-css-extract-plugin
export default {"root":"IconWhatsapp_root__I0fkX"};